<template>
  <Modal title="规则内容" width="1058" v-model="state" transfer>
    <el-table :data="data" border stripe>
      <el-table-column v-for="(col, id) in columns" :key="id" :min-width="col.width" :label="col.title">
        <template slot-scope="scope">
          <span v-if="col.key === 'consume'">
            <Table :columns="consumeColumns" :data="scope.row[col.key]"> </Table>
          </span>
          <span v-else-if="col.key === 'triggerRules'">
            <span style="display: block"> 实际总消耗 &gt;= {{ scope.row.sumAmountPercent }}%设定消耗值； </span>
            <span style="display: block"> 创角总ROI &lt;= {{ scope.row.roi }}% </span>
          </span>
          <span v-else-if="col.key === 'shutDownCondition'">
            <span style="display: block"> 新创角付费数 &lt;= {{ scope.row.condiNewPayUserNum }}个； </span>
            <span style="display: block"> 新创角付费金额 &lt;= {{ scope.row.condiNewRoleMoney }}元； </span>
            <span style="display: block"> 计划流水 &lt;= {{ scope.row.condiSumMoney }}元 </span>
          </span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <Button type="primary" @click="$emit('input', false)">知道了</Button>
    </template>
  </Modal>
</template>
<script>
export default {
  name: 'taskDetail',
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  filters: {},
  data() {
    return {
      columns: [
        {
          title: '任务ID',
          key: 'ruleId',
          width: 28
        },
        {
          title: '消耗配置',
          key: 'consume',
          width: 180
        },
        {
          title: '触发规则',
          key: 'triggerRules',
          width: 98
        },
        {
          title: '计划关停条件',
          key: 'shutDownCondition'
        }
      ],
      consumeColumns: [
        {
          title: '周一',
          key: 'mondayVal',
          tooltip: true
        },
        {
          title: '周二',
          key: 'tuesdayVal',
          tooltip: true
        },
        {
          title: '周三',
          key: 'wednesdayVal',
          tooltip: true
        },
        {
          title: '周四',
          key: 'thursdayVal',
          tooltip: true
        },
        {
          title: '周五',
          key: 'fridayVal',
          tooltip: true
        },
        {
          title: '周六',
          key: 'saturdayVal',
          tooltip: true
        },
        {
          title: '周日',
          key: 'sundayVal',
          tooltip: true
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.block-span {
  display: block;
}

.m-condition {
  padding: 8px 0;
}

::v-deep .ivu-table-cell {
  line-height: 22px;
}
</style>
